// extracted by css-extract-rspack-plugin
var _1 = "filter-X8Ui24";
var _2 = "table-q38St9";
export { _1 as "filter", _2 as "table" }
